import CONNECTION_RETURN_QUERY_KEY from './connectionReturnQueryKey.js';

/**
 * Where a sign-in started from a connection card comes back to: the conversation, naming the card, so
 * the conversation can continue once the card is connected (`pieveReturnPath` on the sign-in link).
 */
const buildConnectionReturnPath = ({ threadId, interactionId }) => {
  return `/threads/${encodeURIComponent(threadId)}?${CONNECTION_RETURN_QUERY_KEY}=${encodeURIComponent(interactionId)}`;
};

export default buildConnectionReturnPath;
